import { useNavigate } from 'react-router-dom';
import styles from './styles.module.scss';
import TrilogicLogo from '../../assets/images/icons/trilogic-icon-login.png';

export const PageNotFound = () => {
    const navigate = useNavigate();

    const goToHomePage = () => {
        navigate('/');
    };

    return (
        <div className={styles.wrapper}>
            <div className={styles.mainLeft}>
                <h1 className={styles.title}>Página não encontrada</h1>
                <button className={styles.loginBox} onClick={goToHomePage}>
                    <div className={`fa fa-reply  ${styles.user}`} />
                </button>
            </div>

            <div className={styles.mainRight}>
                <img src={TrilogicLogo} alt='Logo do Trilogic' />
            </div>
        </div>
    );
};
